import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=281fa7a2&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=281fa7a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fa7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281fa7a2')) {
      api.createRecord('281fa7a2', component.options)
    } else {
      api.reload('281fa7a2', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=281fa7a2&scoped=true", function () {
      api.rerender('281fa7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/vehicle/components/tableData.vue"
export default component.exports